const GROUP_CODE_DEFAULT = "_DEFAULT_";
const GROUP_CODE_VAX_PRE_REGISTER = "VAX_PRE_REGISTER";
const GROUP_CODE_DEFAULT_MX = "_DEFAULT_MX_";

export {
  GROUP_CODE_DEFAULT,
  GROUP_CODE_VAX_PRE_REGISTER,
  GROUP_CODE_DEFAULT_MX
};
